import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, FileText } from 'lucide-react';

export const ResearchReportsCard = ({
  title = 'View All IPO Reports',
  subtitle = 'Historical listing gains & subscription data',
  body = 'Browse draft prospectus analysis, grey market premium trends and broker ratings for recent issues.',
  linkLabel = 'Browse Research Reports',
  to = '/ipo-dashboard',
}) => (
  <section aria-labelledby="research-reports-heading" className="bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5">
    <div className="flex items-start gap-3">
      <span className="w-9 h-9 rounded-xl bg-teal-50 text-[#008080] border border-teal-100 flex items-center justify-center flex-shrink-0">
        <FileText className="w-4 h-4" />
      </span>
      <div>
        <h2 id="research-reports-heading" className="text-sm font-extrabold text-slate-900">
          {title}
        </h2>
        <p className="text-[11px] text-slate-500">{subtitle}</p>
      </div>
    </div>
    <p className="mt-3 text-xs text-slate-600 leading-relaxed">{body}</p>
    <Link
      to={to}
      className="mt-4 flex items-center justify-between gap-2 px-3 py-2 rounded-lg border border-slate-200 text-xs font-bold text-slate-700 hover:border-[#008080] hover:text-[#008080] transition-colors"
    >
      {linkLabel}
      <ArrowRight className="w-3.5 h-3.5" />
    </Link>
  </section>
);

export default ResearchReportsCard;
